import { defineMessages } from '@/i18n'

/** The Users admin: people, roles and AU logins (docs/user-management.md). */
export const usersMessages = defineMessages({
  en: {
    intro: 'Every AU account is listed here. A person reaches the modules of their roles, plus any extra pages you tick for them.',
    tabPeople: 'People',
    tabRoles: 'Roles',
    colUser: 'User',
    colAuType: 'AU type',
    colAccess: 'Access',
    colCanEdit: 'Can edit',
    colLastLogin: 'Last login',
    colRoles: 'Roles',
    admin: 'Admin',
    noAccess: 'no access',
    denied: 'not admitted',
    unknown: '(unknown)',
    empty: 'No one matches.',
    search: 'Search name, username, email, company',
    filter_active: 'Active',
    filter_access: 'With access',
    filter_noAccess: 'No access yet',
    filter_never: 'Never signed in',
    filter_off: 'Switched off',
    filter_all: 'All',
    neverSignedIn: 'never',
    switchedOff: 'switched off',
    selectAll: 'Select all shown',
    selected: '{n} selected',
    giveRole: 'Give role',
    giveRoleApply: 'Add to selected',
    bulkDone: '{n} updated, {skipped} skipped (switched off or not admitted).',
    clearSelection: 'Clear',
    newLogin: 'New AU login',
    auOff: "Creating AU logins isn't set up on this server yet.",
    pageDashboard: 'Dashboard',
    pageRtk: 'RTK',
    pageAufmass: 'Aufmaß',
    pageProjects: 'Projects',
    pageBonus: 'Bonus',
    pageUsers: 'Users (admin area)',
    pageInventory: 'Inventory (view)',
    pageInventoryMove: 'Inventory movements (scan, move, print labels)',
    pageFleet: 'Fleet (view)',
    pageFleetMove: 'Fleet bookings (reserve, check out, check in)',
    pageBilling: 'Billing (view)',
    pageBillingManage: 'Billing (contracts, statements)',
    pagePeople: 'People (papers, subcontractor certificates)',
    rolesTitle: 'Roles',
    rolesHint: 'A role opens its modules and decides who signs project gates.',
    suggestedRole: 'AU login type suggests: {roles}',
    useSuggestion: 'Use',
    roleOpens: 'Opens: {pages}',
    noModules: 'no modules',
    modulesTitle: 'Modules',
    modulesHint: 'Shaded ones come with a role. Tick others to give this person extra pages.',
    fromRole: 'role',
    fullAdmin: 'Full admin',
    fullAdminHint: 'Access to everything, including this Users page.',
    adminHasAllPages: 'Admins have every page.',
    adminOnlyAdmin: 'Only an administrator can change an administrator.',
    canEditHint: 'May correct Aufmaß cells & project data (not just view).',
    canEditFromRole: "One of this person's roles already carries the edit right.",
    offHint: "This AU account is switched off: it can't sign in to AU or here.",
    deniedHint: 'This AU login type is never admitted to Aufmass.',
    couldNotSave: 'Could not save.',
    saving: 'Saving…',
    auAccount: 'AU login',
    auAccountHint: 'The login itself. Changes apply in AU too.',
    auAdminOnly: 'Only an administrator can change this login.',
    resetPassword: 'New password',
    resetConfirm: 'Give {name} a new password? The old one stops working in AU and here.',
    switchOff: 'Switch off',
    switchOn: 'Switch on',
    switchOffConfirm: 'Switch off {name}? They can no longer sign in to AU or here; open sessions end within two minutes.',
    editDetails: 'Edit AU details',
    confirm: 'Yes, continue',
    createTitle: 'New AU login',
    createHint: 'Creates the login in AU (it works in AU and here) and sets up access in one step.',
    firstName: 'First name',
    lastName: 'Last name',
    username: 'Username',
    usernameHint: "What they type to sign in. Can't be changed later.",
    email: 'Email (optional)',
    auType: 'AU login type',
    company: 'Company',
    none: '— none —',
    employee: 'Linked employee (optional)',
    employeeSearch: "Search AU's staff list…",
    hasLogin: 'has a login',
    create: 'Create login',
    creating: 'Creating…',
    credentialsTitle: 'Login created',
    credentialsHint: 'Hand this over in person. The password is shown only now; later it can only be replaced.',
    password: 'Password',
    copy: 'Copy',
    copied: 'Copied',
    done: 'Done',
    rolesIntro: 'A role opens modules. A person reaches every module of every role they hold, plus extra pages ticked on them.',
    roleChangesLive: 'Changes reach signed-in people within two minutes.',
    adminOnlyRoles: 'Only an administrator can change roles.',
    colRole: 'Role',
    colModules: 'Modules',
    colHolders: 'People',
    builtin: 'built-in',
    newRole: 'New role',
    editRole: 'Edit role',
    roleKey: 'Key',
    roleKeyHint: "Lowercase letters, digits and _, e.g. viewer. Can't be changed later.",
    roleName: 'Name',
    roleDescription: 'Description (optional)',
    roleCanEdit: 'Holders may edit',
    usersPageNotByRole: 'The Users page is granted per person, never by role.',
    deleteRole: 'Delete role',
    deleteRoleConfirm: 'Delete the role {name}?',
  },
  de: {
    intro: 'Hier steht jedes AU-Konto. Eine Person erreicht die Module ihrer Rollen und zusätzlich jede Seite, die Sie ihr einzeln freigeben.',
    tabPeople: 'Personen',
    tabRoles: 'Rollen',
    colUser: 'Benutzer',
    colAuType: 'AU-Typ',
    colAccess: 'Zugriff',
    colCanEdit: 'Darf bearbeiten',
    colLastLogin: 'Letzte Anmeldung',
    colRoles: 'Rollen',
    admin: 'Admin',
    noAccess: 'kein Zugriff',
    denied: 'nicht zugelassen',
    unknown: '(unbekannt)',
    empty: 'Niemand passt.',
    search: 'Name, Benutzername, E-Mail, Firma suchen',
    filter_active: 'Aktiv',
    filter_access: 'Mit Zugriff',
    filter_noAccess: 'Noch ohne Zugriff',
    filter_never: 'Nie angemeldet',
    filter_off: 'Abgeschaltet',
    filter_all: 'Alle',
    neverSignedIn: 'nie',
    switchedOff: 'abgeschaltet',
    selectAll: 'Alle angezeigten auswählen',
    selected: '{n} ausgewählt',
    giveRole: 'Rolle geben',
    giveRoleApply: 'Den Ausgewählten geben',
    bulkDone: '{n} geändert, {skipped} übersprungen (abgeschaltet oder nicht zugelassen).',
    clearSelection: 'Aufheben',
    newLogin: 'Neuer AU-Login',
    auOff: 'Das Anlegen von AU-Logins ist auf diesem Server noch nicht eingerichtet.',
    pageDashboard: 'Übersicht',
    pageRtk: 'RTK',
    pageAufmass: 'Aufmaß',
    pageProjects: 'Projekte',
    pageBonus: 'Bonus',
    pageUsers: 'Benutzer (Adminbereich)',
    pageInventory: 'Lager (ansehen)',
    pageInventoryMove: 'Lagerbewegungen (scannen, bewegen, Etiketten drucken)',
    pageFleet: 'Fuhrpark (ansehen)',
    pageFleetMove: 'Fuhrpark-Buchungen (buchen, ausgeben, zurücknehmen)',
    pageBilling: 'Abrechnung (ansehen)',
    pageBillingManage: 'Abrechnung (Verträge, Aufstellungen)',
    pagePeople: 'Personal (Nachweise, Nachunternehmer)',
    rolesTitle: 'Rollen',
    rolesHint: 'Eine Rolle öffnet ihre Module und legt fest, wer Projekttore unterschreibt.',
    suggestedRole: 'AU-Logintyp schlägt vor: {roles}',
    useSuggestion: 'Übernehmen',
    roleOpens: 'Öffnet: {pages}',
    noModules: 'keine Module',
    modulesTitle: 'Module',
    modulesHint: 'Hinterlegte kommen mit einer Rolle. Weitere ankreuzen, um dieser Person zusätzliche Seiten zu geben.',
    fromRole: 'Rolle',
    fullAdmin: 'Voller Admin',
    fullAdminHint: 'Zugriff auf alles, auch auf diese Benutzerseite.',
    adminHasAllPages: 'Admins haben jede Seite.',
    adminOnlyAdmin: 'Nur ein Administrator kann einen Administrator ändern.',
    canEditHint: 'Darf Aufmaß-Zellen und Projektdaten korrigieren (nicht nur ansehen).',
    canEditFromRole: 'Eine Rolle dieser Person bringt das Bearbeitungsrecht bereits mit.',
    offHint: 'Dieses AU-Konto ist abgeschaltet: Es kann sich weder in AU noch hier anmelden.',
    deniedHint: 'Dieser AU-Logintyp wird in Aufmass nie zugelassen.',
    couldNotSave: 'Speichern fehlgeschlagen.',
    saving: 'Speichern…',
    auAccount: 'AU-Login',
    auAccountHint: 'Der Login selbst. Änderungen gelten auch in AU.',
    auAdminOnly: 'Nur ein Administrator kann diesen Login ändern.',
    resetPassword: 'Neues Passwort',
    resetConfirm: '{name} ein neues Passwort geben? Das alte gilt dann weder in AU noch hier.',
    switchOff: 'Abschalten',
    switchOn: 'Einschalten',
    switchOffConfirm: '{name} abschalten? Die Person kann sich weder in AU noch hier anmelden; offene Sitzungen enden binnen zwei Minuten.',
    editDetails: 'AU-Daten bearbeiten',
    confirm: 'Ja, weiter',
    createTitle: 'Neuer AU-Login',
    createHint: 'Legt den Login in AU an (er gilt in AU und hier) und richtet den Zugriff in einem Schritt ein.',
    firstName: 'Vorname',
    lastName: 'Nachname',
    username: 'Benutzername',
    usernameHint: 'Das tippt die Person beim Anmelden. Später nicht änderbar.',
    email: 'E-Mail (optional)',
    auType: 'AU-Logintyp',
    company: 'Firma',
    none: '— keine —',
    employee: 'Verknüpfter Mitarbeiter (optional)',
    employeeSearch: 'In der AU-Mitarbeiterliste suchen…',
    hasLogin: 'hat einen Login',
    create: 'Login anlegen',
    creating: 'Wird angelegt…',
    credentialsTitle: 'Login angelegt',
    credentialsHint: 'Persönlich übergeben. Das Passwort wird nur jetzt angezeigt; später lässt es sich nur ersetzen.',
    password: 'Passwort',
    copy: 'Kopieren',
    copied: 'Kopiert',
    done: 'Fertig',
    rolesIntro: 'Eine Rolle öffnet Module. Eine Person erreicht jedes Modul jeder ihrer Rollen, dazu einzeln freigegebene Seiten.',
    roleChangesLive: 'Änderungen erreichen angemeldete Personen binnen zwei Minuten.',
    adminOnlyRoles: 'Nur ein Administrator kann Rollen ändern.',
    colRole: 'Rolle',
    colModules: 'Module',
    colHolders: 'Personen',
    builtin: 'eingebaut',
    newRole: 'Neue Rolle',
    editRole: 'Rolle bearbeiten',
    roleKey: 'Schlüssel',
    roleKeyHint: 'Kleinbuchstaben, Ziffern und _, z. B. viewer. Später nicht änderbar.',
    roleName: 'Name',
    roleDescription: 'Beschreibung (optional)',
    roleCanEdit: 'Inhaber dürfen bearbeiten',
    usersPageNotByRole: 'Die Benutzerseite wird pro Person freigegeben, nie über eine Rolle.',
    deleteRole: 'Rolle löschen',
    deleteRoleConfirm: 'Rolle {name} löschen?',
  },
  cnr: {
    intro: 'Ovdje je svaki AU nalog. Osoba vidi module svojih uloga i dodatne stranice koje joj pojedinačno dodijelite.',
    tabPeople: 'Osobe',
    tabRoles: 'Uloge',
    colUser: 'Korisnik',
    colAuType: 'AU tip',
    colAccess: 'Pristup',
    colCanEdit: 'Smije mijenjati',
    colLastLogin: 'Zadnja prijava',
    colRoles: 'Uloge',
    admin: 'Admin',
    noAccess: 'bez pristupa',
    denied: 'nije dozvoljen',
    unknown: '(nepoznato)',
    empty: 'Nema rezultata.',
    search: 'Traži ime, korisničko ime, e-mail, firmu',
    filter_active: 'Aktivni',
    filter_access: 'S pristupom',
    filter_noAccess: 'Još bez pristupa',
    filter_never: 'Nikad prijavljeni',
    filter_off: 'Isključeni',
    filter_all: 'Svi',
    neverSignedIn: 'nikad',
    switchedOff: 'isključen',
    selectAll: 'Označi sve prikazane',
    selected: 'Označeno: {n}',
    giveRole: 'Dodijeli ulogu',
    giveRoleApply: 'Dodaj označenima',
    bulkDone: 'Ažurirano: {n}, preskočeno: {skipped} (isključeni ili nedozvoljeni).',
    clearSelection: 'Poništi',
    newLogin: 'Novi AU nalog',
    auOff: 'Kreiranje AU naloga još nije podešeno na ovom serveru.',
    pageDashboard: 'Pregled',
    pageRtk: 'RTK',
    pageAufmass: 'Aufmaß',
    pageProjects: 'Projekti',
    pageBonus: 'Bonus',
    pageUsers: 'Korisnici (administracija)',
    pageInventory: 'Magacin (pregled)',
    pageInventoryMove: 'Kretanje magacina (skeniranje, premještanje, štampa etiketa)',
    pageFleet: 'Vozni park (pregled)',
    pageFleetMove: 'Vozni park (rezervacija, zaduženje, razduženje)',
    pageBilling: 'Naplata (pregled)',
    pageBillingManage: 'Naplata (ugovori, obračuni)',
    pagePeople: 'Ljudi (dokumenti, podizvođači)',
    rolesTitle: 'Uloge',
    rolesHint: 'Uloga otvara svoje module i određuje ko potpisuje kapije projekta.',
    suggestedRole: 'Tip prijave u AU predlaže: {roles}',
    useSuggestion: 'Preuzmi',
    roleOpens: 'Otvara: {pages}',
    noModules: 'bez modula',
    modulesTitle: 'Moduli',
    modulesHint: 'Osjenčeni dolaze s ulogom. Označite druge da ovoj osobi date dodatne stranice.',
    fromRole: 'uloga',
    fullAdmin: 'Puna administratorska prava',
    fullAdminHint: 'Pristup svemu, uključujući ovu stranicu Korisnici.',
    adminHasAllPages: 'Administratori imaju sve stranice.',
    adminOnlyAdmin: 'Samo administrator može mijenjati administratora.',
    canEditHint: 'Smije ispravljati Aufmaß ćelije i podatke projekta (ne samo pregledati).',
    canEditFromRole: 'Jedna od uloga ove osobe već nosi pravo izmjene.',
    offHint: 'Ovaj AU nalog je isključen: ne može se prijaviti ni u AU ni ovdje.',
    deniedHint: 'Ovaj AU tip prijave nikad nema pristup Aufmassu.',
    couldNotSave: 'Spašavanje nije uspjelo.',
    saving: 'Spašavanje…',
    auAccount: 'AU nalog',
    auAccountHint: 'Sam nalog. Izmjene važe i u AU.',
    auAdminOnly: 'Samo administrator može mijenjati ovaj nalog.',
    resetPassword: 'Nova lozinka',
    resetConfirm: 'Dati {name} novu lozinku? Stara prestaje važiti u AU i ovdje.',
    switchOff: 'Isključi',
    switchOn: 'Uključi',
    switchOffConfirm: 'Isključiti {name}? Više se ne može prijaviti u AU ni ovdje; otvorene sesije ističu za dvije minute.',
    editDetails: 'Uredi AU podatke',
    confirm: 'Da, nastavi',
    createTitle: 'Novi AU nalog',
    createHint: 'Kreira nalog u AU (važi u AU i ovdje) i odmah podešava pristup.',
    firstName: 'Ime',
    lastName: 'Prezime',
    username: 'Korisničko ime',
    usernameHint: 'Ono što kuca pri prijavi. Kasnije se ne može mijenjati.',
    email: 'E-mail (neobavezno)',
    auType: 'AU tip prijave',
    company: 'Firma',
    none: '— nijedna —',
    employee: 'Povezani radnik (neobavezno)',
    employeeSearch: 'Traži u AU listi radnika…',
    hasLogin: 'ima nalog',
    create: 'Kreiraj nalog',
    creating: 'Kreiranje…',
    credentialsTitle: 'Nalog kreiran',
    credentialsHint: 'Predajte lično. Lozinka se prikazuje samo sada; kasnije se može samo zamijeniti.',
    password: 'Lozinka',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    done: 'Gotovo',
    rolesIntro: 'Uloga otvara module. Osoba vidi svaki modul svake svoje uloge, plus pojedinačno dodijeljene stranice.',
    roleChangesLive: 'Izmjene stižu do prijavljenih osoba za dvije minute.',
    adminOnlyRoles: 'Samo administrator može mijenjati uloge.',
    colRole: 'Uloga',
    colModules: 'Moduli',
    colHolders: 'Osobe',
    builtin: 'ugrađena',
    newRole: 'Nova uloga',
    editRole: 'Uredi ulogu',
    roleKey: 'Ključ',
    roleKeyHint: 'Mala slova, cifre i _, npr. viewer. Kasnije se ne može mijenjati.',
    roleName: 'Naziv',
    roleDescription: 'Opis (neobavezno)',
    roleCanEdit: 'Nosioci smiju mijenjati',
    usersPageNotByRole: 'Stranica Korisnici se dodjeljuje po osobi, nikad kroz ulogu.',
    deleteRole: 'Obriši ulogu',
    deleteRoleConfirm: 'Obrisati ulogu {name}?',
  },
  bs: {
    intro: 'Ovdje je svaki AU nalog. Osoba vidi module svojih uloga i dodatne stranice koje joj pojedinačno dodijelite.',
    tabPeople: 'Osobe',
    tabRoles: 'Uloge',
    colUser: 'Korisnik',
    colAuType: 'AU tip',
    colAccess: 'Pristup',
    colCanEdit: 'Smije mijenjati',
    colLastLogin: 'Zadnja prijava',
    colRoles: 'Uloge',
    admin: 'Admin',
    noAccess: 'bez pristupa',
    denied: 'nije dozvoljen',
    unknown: '(nepoznato)',
    empty: 'Nema rezultata.',
    search: 'Traži ime, korisničko ime, e-mail, firmu',
    filter_active: 'Aktivni',
    filter_access: 'S pristupom',
    filter_noAccess: 'Još bez pristupa',
    filter_never: 'Nikad prijavljeni',
    filter_off: 'Isključeni',
    filter_all: 'Svi',
    neverSignedIn: 'nikad',
    switchedOff: 'isključen',
    selectAll: 'Označi sve prikazane',
    selected: 'Označeno: {n}',
    giveRole: 'Dodijeli ulogu',
    giveRoleApply: 'Dodaj označenima',
    bulkDone: 'Ažurirano: {n}, preskočeno: {skipped} (isključeni ili nedozvoljeni).',
    clearSelection: 'Poništi',
    newLogin: 'Novi AU nalog',
    auOff: 'Kreiranje AU naloga još nije podešeno na ovom serveru.',
    pageDashboard: 'Pregled',
    pageRtk: 'RTK',
    pageAufmass: 'Aufmaß',
    pageProjects: 'Projekti',
    pageBonus: 'Bonus',
    pageUsers: 'Korisnici (administracija)',
    pageInventory: 'Magacin (pregled)',
    pageInventoryMove: 'Kretanje magacina (skeniranje, premještanje, štampa etiketa)',
    pageFleet: 'Vozni park (pregled)',
    pageFleetMove: 'Vozni park (rezervacija, zaduženje, razduženje)',
    pageBilling: 'Naplata (pregled)',
    pageBillingManage: 'Naplata (ugovori, obračuni)',
    pagePeople: 'Ljudi (dokumenti, podizvođači)',
    rolesTitle: 'Uloge',
    rolesHint: 'Uloga otvara svoje module i određuje ko potpisuje kapije projekta.',
    suggestedRole: 'Tip prijave u AU predlaže: {roles}',
    useSuggestion: 'Preuzmi',
    roleOpens: 'Otvara: {pages}',
    noModules: 'bez modula',
    modulesTitle: 'Moduli',
    modulesHint: 'Osjenčeni dolaze s ulogom. Označite druge da ovoj osobi date dodatne stranice.',
    fromRole: 'uloga',
    fullAdmin: 'Puna administratorska prava',
    fullAdminHint: 'Pristup svemu, uključujući ovu stranicu Korisnici.',
    adminHasAllPages: 'Administratori imaju sve stranice.',
    adminOnlyAdmin: 'Samo administrator može mijenjati administratora.',
    canEditHint: 'Smije ispravljati Aufmaß ćelije i podatke projekta (ne samo pregledati).',
    canEditFromRole: 'Jedna od uloga ove osobe već nosi pravo izmjene.',
    offHint: 'Ovaj AU nalog je isključen: ne može se prijaviti ni u AU ni ovdje.',
    deniedHint: 'Ovaj AU tip prijave nikad nema pristup Aufmassu.',
    couldNotSave: 'Spašavanje nije uspjelo.',
    saving: 'Spašavanje…',
    auAccount: 'AU nalog',
    auAccountHint: 'Sam nalog. Izmjene važe i u AU.',
    auAdminOnly: 'Samo administrator može mijenjati ovaj nalog.',
    resetPassword: 'Nova lozinka',
    resetConfirm: 'Dati {name} novu lozinku? Stara prestaje važiti u AU i ovdje.',
    switchOff: 'Isključi',
    switchOn: 'Uključi',
    switchOffConfirm: 'Isključiti {name}? Više se ne može prijaviti u AU ni ovdje; otvorene sesije ističu za dvije minute.',
    editDetails: 'Uredi AU podatke',
    confirm: 'Da, nastavi',
    createTitle: 'Novi AU nalog',
    createHint: 'Kreira nalog u AU (važi u AU i ovdje) i odmah podešava pristup.',
    firstName: 'Ime',
    lastName: 'Prezime',
    username: 'Korisničko ime',
    usernameHint: 'Ono što kuca pri prijavi. Kasnije se ne može mijenjati.',
    email: 'E-mail (neobavezno)',
    auType: 'AU tip prijave',
    company: 'Firma',
    none: '— nijedna —',
    employee: 'Povezani radnik (neobavezno)',
    employeeSearch: 'Traži u AU listi radnika…',
    hasLogin: 'ima nalog',
    create: 'Kreiraj nalog',
    creating: 'Kreiranje…',
    credentialsTitle: 'Nalog kreiran',
    credentialsHint: 'Predajte lično. Lozinka se prikazuje samo sada; kasnije se može samo zamijeniti.',
    password: 'Lozinka',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    done: 'Gotovo',
    rolesIntro: 'Uloga otvara module. Osoba vidi svaki modul svake svoje uloge, plus pojedinačno dodijeljene stranice.',
    roleChangesLive: 'Izmjene stižu do prijavljenih osoba za dvije minute.',
    adminOnlyRoles: 'Samo administrator može mijenjati uloge.',
    colRole: 'Uloga',
    colModules: 'Moduli',
    colHolders: 'Osobe',
    builtin: 'ugrađena',
    newRole: 'Nova uloga',
    editRole: 'Uredi ulogu',
    roleKey: 'Ključ',
    roleKeyHint: 'Mala slova, cifre i _, npr. viewer. Kasnije se ne može mijenjati.',
    roleName: 'Naziv',
    roleDescription: 'Opis (neobavezno)',
    roleCanEdit: 'Nosioci smiju mijenjati',
    usersPageNotByRole: 'Stranica Korisnici se dodjeljuje po osobi, nikad kroz ulogu.',
    deleteRole: 'Obriši ulogu',
    deleteRoleConfirm: 'Obrisati ulogu {name}?',
  },
  sr: {
    intro: 'Ovde je svaki AU nalog. Osoba vidi module svojih uloga i dodatne stranice koje joj pojedinačno dodelite.',
    tabPeople: 'Osobe',
    tabRoles: 'Uloge',
    colUser: 'Korisnik',
    colAuType: 'AU tip',
    colAccess: 'Pristup',
    colCanEdit: 'Može menjati',
    colLastLogin: 'Poslednja prijava',
    colRoles: 'Uloge',
    admin: 'Admin',
    noAccess: 'bez pristupa',
    denied: 'nije dozvoljen',
    unknown: '(nepoznato)',
    empty: 'Nema rezultata.',
    search: 'Traži ime, korisničko ime, e-mail, firmu',
    filter_active: 'Aktivni',
    filter_access: 'Sa pristupom',
    filter_noAccess: 'Još bez pristupa',
    filter_never: 'Nikad prijavljeni',
    filter_off: 'Isključeni',
    filter_all: 'Svi',
    neverSignedIn: 'nikad',
    switchedOff: 'isključen',
    selectAll: 'Označi sve prikazane',
    selected: 'Označeno: {n}',
    giveRole: 'Dodeli ulogu',
    giveRoleApply: 'Dodaj označenima',
    bulkDone: 'Ažurirano: {n}, preskočeno: {skipped} (isključeni ili nedozvoljeni).',
    clearSelection: 'Poništi',
    newLogin: 'Novi AU nalog',
    auOff: 'Kreiranje AU naloga još nije podešeno na ovom serveru.',
    pageDashboard: 'Pregled',
    pageRtk: 'RTK',
    pageAufmass: 'Aufmaß',
    pageProjects: 'Projekti',
    pageBonus: 'Bonus',
    pageUsers: 'Korisnici (administracija)',
    pageInventory: 'Magacin (pregled)',
    pageInventoryMove: 'Kretanje magacina (skeniranje, premeštanje, štampa etiketa)',
    pageFleet: 'Vozni park (pregled)',
    pageFleetMove: 'Vozni park (rezervacija, zaduženje, razduženje)',
    pageBilling: 'Naplata (pregled)',
    pageBillingManage: 'Naplata (ugovori, obračuni)',
    pagePeople: 'Ljudi (dokumenti, podizvođači)',
    rolesTitle: 'Uloge',
    rolesHint: 'Uloga otvara svoje module i određuje ko potpisuje kapije projekta.',
    suggestedRole: 'Tip prijave u AU predlaže: {roles}',
    useSuggestion: 'Preuzmi',
    roleOpens: 'Otvara: {pages}',
    noModules: 'bez modula',
    modulesTitle: 'Moduli',
    modulesHint: 'Osenčeni dolaze sa ulogom. Označite druge da ovoj osobi date dodatne stranice.',
    fromRole: 'uloga',
    fullAdmin: 'Puna administratorska prava',
    fullAdminHint: 'Pristup svemu, uključujući ovu stranicu Korisnici.',
    adminHasAllPages: 'Administratori imaju sve stranice.',
    adminOnlyAdmin: 'Samo administrator može menjati administratora.',
    canEditHint: 'Sme ispravljati Aufmaß ćelije i podatke projekta (ne samo pregledati).',
    canEditFromRole: 'Jedna od uloga ove osobe već nosi pravo izmene.',
    offHint: 'Ovaj AU nalog je isključen: ne može se prijaviti ni u AU ni ovde.',
    deniedHint: 'Ovaj AU tip prijave nikad nema pristup Aufmassu.',
    couldNotSave: 'Čuvanje nije uspelo.',
    saving: 'Čuvanje…',
    auAccount: 'AU nalog',
    auAccountHint: 'Sam nalog. Izmene važe i u AU.',
    auAdminOnly: 'Samo administrator može menjati ovaj nalog.',
    resetPassword: 'Nova lozinka',
    resetConfirm: 'Dati {name} novu lozinku? Stara prestaje da važi u AU i ovde.',
    switchOff: 'Isključi',
    switchOn: 'Uključi',
    switchOffConfirm: 'Isključiti {name}? Više ne može da se prijavi u AU ni ovde; otvorene sesije ističu za dva minuta.',
    editDetails: 'Uredi AU podatke',
    confirm: 'Da, nastavi',
    createTitle: 'Novi AU nalog',
    createHint: 'Kreira nalog u AU (važi u AU i ovde) i odmah podešava pristup.',
    firstName: 'Ime',
    lastName: 'Prezime',
    username: 'Korisničko ime',
    usernameHint: 'Ono što kuca pri prijavi. Kasnije ne može da se menja.',
    email: 'E-mail (neobavezno)',
    auType: 'AU tip prijave',
    company: 'Firma',
    none: '— nijedna —',
    employee: 'Povezani radnik (neobavezno)',
    employeeSearch: 'Traži u AU listi radnika…',
    hasLogin: 'ima nalog',
    create: 'Kreiraj nalog',
    creating: 'Kreiranje…',
    credentialsTitle: 'Nalog kreiran',
    credentialsHint: 'Predajte lično. Lozinka se prikazuje samo sada; kasnije može samo da se zameni.',
    password: 'Lozinka',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    done: 'Gotovo',
    rolesIntro: 'Uloga otvara module. Osoba vidi svaki modul svake svoje uloge, plus pojedinačno dodeljene stranice.',
    roleChangesLive: 'Izmene stižu do prijavljenih osoba za dva minuta.',
    adminOnlyRoles: 'Samo administrator može menjati uloge.',
    colRole: 'Uloga',
    colModules: 'Moduli',
    colHolders: 'Osobe',
    builtin: 'ugrađena',
    newRole: 'Nova uloga',
    editRole: 'Uredi ulogu',
    roleKey: 'Ključ',
    roleKeyHint: 'Mala slova, cifre i _, npr. viewer. Kasnije ne može da se menja.',
    roleName: 'Naziv',
    roleDescription: 'Opis (neobavezno)',
    roleCanEdit: 'Nosioci smeju menjati',
    usersPageNotByRole: 'Stranica Korisnici se dodeljuje po osobi, nikad kroz ulogu.',
    deleteRole: 'Obriši ulogu',
    deleteRoleConfirm: 'Obrisati ulogu {name}?',
  },
})
